import { NewUploadScreen } from 'modules/files/screens/NewUploadScreen'

export const LandingPage = () => {
  /* --- Section 6: Render --- */
  return <NewUploadScreen />
}
